import { useMutation } from '@tanstack/react-query'
import { graphql } from 'ms-client/graphql/user-pool'

import { useGetMapByIdForPublic } from '~map-access/queries/useGetMapByIdForPublic'
import { useGetUserById } from '~map-access/queries/useGetUserById'
import {
  CreateMapAccessMutation,
  CreateMapAccessMutationVariables
} from '~map-access/types/__generated/gql/graphql'

const createMapAccessMutation = /* GraphQL */ `
  mutation CreateMapAccess(
    $mapId: ID!
    $email: String!
    $role: INVITED_USER_ROLE
  ) {
    createMapAccess(mapId: $mapId, email: $email, role: $role)
  }
`

const createMapAccesKey = (mapId?: string, email?: string) => [
  'createMapAccess',
  mapId,
  email
]

export const useCreateMapAccess = () => {
  const { data: map } = useGetMapByIdForPublic()
  const { data: user } = useGetUserById()

  return useMutation({
    mutationKey: createMapAccesKey(map?.id, user?.email),
    mutationFn: async (variables: any) => {
      const { role } = variables

      if (!map || !user) return

      const data = await graphql<
        CreateMapAccessMutation,
        CreateMapAccessMutationVariables
      >({
        query: createMapAccessMutation,
        variables: {
          mapId: map?.id,
          email: user?.email,
          role: role
        }
      })

      return data?.createMapAccess
    }
  })
}
